import correct from '@/assets/img/documents/house-hold/polisa.jpg';
import wrong from '@/assets/img/documents/house-hold/polisa-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const INSURERS_POLICY_NAME = 'insurers_policy';

const InsurerPolicy = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać polisę?'),
    steps: [
      i18n.t('Upewnij się, że polisa była ważna w dniu zdarzenia.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony polisy.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Polisa ubezpieczyciela')}
        instructionProps={instructionProps}
        inputFieldName={INSURERS_POLICY_NAME}
        required
        attachmentTypeId={ATTACHMENT_TYPES.POLISA_OC}
        data-testid={`${INSURERS_POLICY_NAME}-uploader`}
      />
    </Card>
  );
};

export default InsurerPolicy;
